import axios from "axios";
import { APIS } from "../../api-factory";
const POST_HEADER = {
  // 'Accept': 'application/json',
  "Content-Type": "application/json",
};

export const CommunityLeadSaveUserApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.res.data)
        })
}

export const CommunityLeadGetUserApi = (userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_LEAD_GET_USER + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            console.log(e)
            error(e.res.data)
        })
}

export const CommunityLeadGetUserLoanApi = (userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_LEAD_GET_USER_LOAN + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            // error(e.res.data)
            console.log(e);
        })
}

export const getNameOnPanApi = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .post(
        APIS.PAN_AUTHENTICATION_API + data.id + "&panNumber=" + data.panNumber,
        {},
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };


  export const CommunityLeadSaveUserBusinessApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER_BUSINESS, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e)
        })
}

export const CommunityLeadGetUserBusinessApi = (userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_LEAD_GET_USER_BUSINESS + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}


export const CommunityLeadSaveUserDirectorApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER_DIRECTOR, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const CommunityLeadGetUserDirectorByUserIdApi = (userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_LEAD_GET_USER_DIRECTOR_BY_USERID + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const CommunityLeadDeleteUserDirectorApi = (id, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.delete(APIS.COM_LEAD_DELETE_USER_DIRECTOR + id, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const CommunityLeadSaveUserAddressApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER_ADDRESS, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const CommunityLeadGetUserAddressApi = (userId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.COM_LEAD_GET_USER_ADDRESS + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const getZipBranchDetailApi = (data, callBack, error) => {
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_BANK_BRANCH_DETAIL + data.code + "&type=" + data.type,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };


  export const CommunityLeadSaveUserLoanApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER_LOAN, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const getStoryLines = (loanId, pageNo, noOfEntry, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_STORY_LINE + loanId + "&pageNo=" + pageNo + "&noOfEntry=" + noOfEntry, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const loanAmounConfigApiNew = (lenderId, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.LOAN_AMOUNT_CONFIG_API + lenderId, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const saveStoryLines = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.SAVE_STORY_LINE, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}
export const getUploadedDocumentsApi = (userId, callBack) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_DOCUMENT_DETAIL + 1 + '&noOfEntry=' + 500 + '&userId=' + userId, headerConfig)
        .then(res => {
            callBack(res.data)
        })

}

export const searchDocName = (name, callBack) => {
    const headerConfig = {
        headers: {},
    };
    axios.get(APIS.GET_DOC_NAME_SEARCH + name, headerConfig)
        .then(res => {
            callBack(res.data)
        })

}


export const uploadzip = (file, type, loanId, userId, docName, docDescription, callBack, error) => {
    console.log(file.type)
    const headerConfig = {
        headers: {},
    };
    let multipartFormData = new FormData()

    multipartFormData.append('file', file)
    multipartFormData.append('loanId', loanId)
    multipartFormData.append('userId', userId)
    multipartFormData.append('type', type)  // direct or extract
    multipartFormData.append('documentName', docName)
    multipartFormData.append('description', docDescription)

    axios.post(APIS.UPLOAD_ZIP_FILE, multipartFormData, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })


}

export const saveUpdateDocumentApi = (file, id, rowData, callBack, error) => {
    console.log(rowData, "rowdata");
    const headerConfig = {
      headers: {},
    };
    // console.log(rowData.licenseId)
    const type =
      file.type === "image/png"
        ? "img"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
        ? "img"
        : file.type === "image/jpeg"
        ? "img"
        : "";
    let multipartFormData = new FormData();
    multipartFormData.append(
      "replaceOrUpload",
      rowData.uploadedOrNot === "N" ? 0 : 1
    );
  
    multipartFormData.append("file", file);
    multipartFormData.append("documentId", id);
    multipartFormData.append("type", type);
    multipartFormData.append("fileName", file.name);
    multipartFormData.append(
      "lenderId",
      rowData.lenderId !== undefined ? rowData.lenderId : ""
    );
    multipartFormData.append(
      "licenseId",
      rowData.licenseId ? rowData.licenseId : LICENCE_ID
    );
    multipartFormData.append(
      "userId",
      rowData.userId !== undefined ? rowData.userId : ""
    );
    multipartFormData.append(
      "loanId",
      rowData.loanId !== undefined ? rowData.loanId : ""
    );
    multipartFormData.append(
      "communityId",
      rowData && rowData.communityId
        ? rowData.communityId
        : window.sessionStorage.getItem("communityId")
    );
  
    // if (rowData.communityId !== null && rowData.communityId !== undefined) {
    //     multipartFormData.append('communityId', rowData.communityId)
    // }
    axios
      .post(APIS.SAVE_UPDATE_DOCUMENT, multipartFormData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };

  export const getDocumentConfigApi = (
    pageNo,
    noOfRows,
    data,
    callBack,
    error
  ) => {
    console.log(data, "data");
    const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
    const product = data.product !== undefined ? data.product : "";
    const bussinessType =
      data.bussinessType !== undefined ? data.bussinessType : "";
    const sourceOfIncome =
      data.sourceOfIncome !== undefined ? data.sourceOfIncome : "";
    const loanId = data.loanId !== undefined ? data.loanId : "";
    const communityId = data.communityId !== undefined ? data.communityId : "";
    const lenderId = data.lenderId !== undefined ? data.lenderId : "";
    const stage = data.stage !== undefined ? data.stage : "";
  
    const headerConfig = {
      headers: {},
    };
    console.log(data);
    axios
      .get(
        APIS.GET_DOCUMENT_CONFIG +
          pageNo +
          "&noOfEntry=" +
          noOfRows +
          "&licenseId=" +
          licenseId +
          "&product=" +
          product +
          "&bussinessType=" +
          bussinessType +
          "&sourceOfIncome=" +
          sourceOfIncome +
          "&loanId=" +
          loanId +
          "&communityId=" +
          communityId +
          "&lenderId=" +
          lenderId +
          "&stage=" +
          stage,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };

  export const getDocumentCountApi = (data, callBack, error) => {
    const licenseId = data.licenseId ? data.licenseId : LICENCE_ID;
    const product = data.product !== undefined ? data.product : "";
    const headerConfig = {
      headers: {},
    };
    axios
      .get(
        APIS.GET_DOCUMENT_TABLE_COUNT + licenseId + "&product=" + product,
        headerConfig
      )
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };


  export const saveUpdateDocumentApiOther = (
    file,
    docName,
    id,
    rowData,
    description,
    replaceOrUpload,
    callBack,
    error
  ) => {
    const type =
      file.type === "image/png"
        ? "img"
        : file.type === "application/pdf"
        ? "pdf"
        : file.type === "image/jpg"
        ? "img"
        : file.type === "image/jpeg"
        ? "img"
        : "";
    const headerConfig = {
      headers: {},
    };
    let multipartFormData = new FormData();
    multipartFormData.append("docName", docName);
    multipartFormData.append("description", description);
    multipartFormData.append("file", file);
    multipartFormData.append("documentId", id ? id : "");
    multipartFormData.append("type", type);
    multipartFormData.append("fileName", file.name);
    multipartFormData.append(
      "lenderId",
      rowData.lenderId !== undefined ? rowData.lenderId : ""
    );
    multipartFormData.append(
      "licenseId",
      rowData.licenseId ? rowData.licenseId : LICENCE_ID
    );
    multipartFormData.append(
      "userId",
      rowData.userId !== undefined ? rowData.userId : ""
    );
    multipartFormData.append(
      "loanId",
      rowData.loanId !== undefined ? rowData.loanId : ""
    );
    multipartFormData.append(
      "communityId",
      rowData && rowData.communityId
        ? rowData.communityId
        : window.sessionStorage.getItem("communityId")
    );
    multipartFormData.append("replaceOrUpload", replaceOrUpload);
  
    axios
      .post(APIS.UPLOAD_OTHER_DOCUMENTS, multipartFormData, headerConfig)
      .then((res) => {
        callBack(res.data);
      })
      .catch((e) => {
        error(e.res.data);
      });
  };


  export const CommunityLeadSaveUserSalaryApi = (data, callBack, error) => {
    const headerConfig = {
        headers: {},
    };
    axios.post(APIS.COM_LEAD_SAVE_USER_SALARIED, data, headerConfig)
        .then(res => {
            callBack(res.data)
        })
        .catch(e => {
            error(e.res.data)
        })
}

export const CommunityLeadGetUserSalaryApi = (userId, callBack, error) => {
  const headerConfig = {
      headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_SALARIED + userId, headerConfig)
      .then(res => {
          callBack(res.data)
      })
      .catch(e => {
          error(e.res.data)
      })
}

export const CommunityLeadSaveUserPropertyApi = (data, callBack, error) => {
  const headerConfig = {
      headers: {},
  };
  axios.post(APIS.COM_LEAD_SAVE_USER_PROPERTY, data, headerConfig)
      .then(res => {
          callBack(res.data)
      })
      .catch(e => {
          // error(e.res.data)
      })
}

export const CommunityLeadGetUserPropertyByUserIdApi = (userId, callBack, error) => {
  const headerConfig = {
      headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_PROPERTY_BY_USERID + userId, headerConfig)
      .then(res => {
          callBack(res.data)
      })
      .catch(e => {
          error(e.res.data)
      })
}

export const CommunityLeadGetUserPropertyByLoanIdApi = (loanId, callBack, error) => {
  const headerConfig = {
      headers: {},
  };
  axios.get(APIS.COM_LEAD_GET_USER_PROPERTY_BY_LOANID + loanId, headerConfig)
      .then(res => {
          callBack(res.data)
      })
      .catch(e => {
          error(e.res.data)
      })
}


export const CommunityLeadDeleteUserPropertyApi = (id, callBack, error) => {
  const headerConfig = {
      headers: {},
  };
  axios.delete(APIS.COM_LEAD_DELETE_USER_PROPERTY + id, headerConfig)
      .then(res => {
          callBack(res.data)
      })
      .catch(e => {
          error(e.res.data)
      })
}
